import React from 'react';
import { setPxStyle, getTransformPropValue, getPxStyle } from './shared';
export class StateType {
    constructor() {
        this.transform = '';
        this.isMoving = false;
        this.showPrev = false;
        this.showNext = false;
    }
}
export class DefaultTabBar extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onPan = (() => {
            let lastOffset = 0;
            let finalOffset = 0;
            const getLastOffset = (isVertical = this.isTabBarVertical()) => {
                let offset = +`${lastOffset}`.replace('%', '');
                if (`${lastOffset}`.indexOf('%') >= 0) {
                    offset /= 100;
                    offset *= isVertical ? this.layout.clientHeight : this.layout.clientWidth;
                }
                return offset;
            };
            return {
                onPanStart: () => {
                    this.setState({ isMoving: true });
                },
                onPanMove: (status) => {
                    if (!status.moveStatus || !this.layout)
                        return;
                    const isVertical = this.isTabBarVertical();
                    let offset = getLastOffset() + (isVertical ? status.moveStatus.y : status.moveStatus.x);
                    const canScrollOffset = isVertical ?
                        -this.layout.scrollHeight + this.layout.clientHeight :
                        -this.layout.scrollWidth + this.layout.clientWidth;
                    offset = Math.min(offset, 0);
                    offset = Math.max(offset, canScrollOffset);
                    setPxStyle(this.layout, offset, 'px', isVertical);
                    finalOffset = offset;
                    this.setState({
                        showPrev: -offset > 0,
                        showNext: offset > canScrollOffset,
                    });
                },
                onPanEnd: () => {
                    const isVertical = this.isTabBarVertical();
                    lastOffset = finalOffset;
                    this.setState({
                        isMoving: false,
                        transform: getPxStyle(finalOffset, 'px', isVertical),
                    });
                },
                setCurrentOffset: (offset) => lastOffset = offset,
            };
        })();
        this.getTransformByIndex = (props) => {
            const { activeTab, tabs, page = 0 } = props;
            const isVertical = this.isTabBarVertical();
            const size = this.getTabSize(page, tabs.length);
            const center = page / 2;
            let pos = Math.min(activeTab, tabs.length - center - .5);
            const skipSize = Math.min(-(pos - center + .5) * size, 0);
            this.onPan.setCurrentOffset(`${skipSize}%`);
            return {
                transform: getPxStyle(skipSize, '%', isVertical),
                showPrev: activeTab > center - .5 && tabs.length > page,
                showNext: activeTab < tabs.length - center - .5 && tabs.length > page,
            };
        };
        this.onPress = (index) => {
            const { goToTab, onTabClick, tabs } = this.props;
            onTabClick && onTabClick(tabs[index], index);
            goToTab && goToTab(index);
        };
        this.isTabBarVertical = (position = this.props.tabBarPosition) => position === 'left' || position === 'right';
        this.renderTab = (t, i, size, isTabBarVertical) => {
            const { prefixCls, renderTab, activeTab, tabBarTextStyle, tabBarActiveTextColor, tabBarInactiveTextColor, } = this.props;
            const textStyle = Object.assign({}, tabBarTextStyle);
            let cls = `${prefixCls}-tab`;
            if (activeTab === i) {
                cls += ` ${cls}-active`;
                if (tabBarActiveTextColor) {
                    textStyle.color = tabBarActiveTextColor;
                }
            }
            else if (tabBarInactiveTextColor) {
                textStyle.color = tabBarInactiveTextColor;
            }
            return <div key={`t_${i}`} style={Object.assign({}, textStyle, isTabBarVertical ? { height: `${size}%` } : { width: `${size}%` })} className={cls} onClick={() => this.onPress(i)}>
      {renderTab ? renderTab(t) : t.title}
    </div>;
        };
        this.setContentLayout = (div) => {
            this.layout = div;
        };
        this.getTabSize = (page, tabLength) => 100 / Math.min(page, tabLength);
        this.state = Object.assign({}, new StateType, this.getTransformByIndex(props));
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.activeTab !== nextProps.activeTab ||
            this.props.tabs !== nextProps.tabs ||
            this.props.tabs.length !== nextProps.tabs.length) {
            this.setState(Object.assign({}, this.getTransformByIndex(nextProps)));
        }
    }
    render() {
        const { prefixCls, animated, tabs = [], page = 0, activeTab = 0, tabBarBackgroundColor, tabBarUnderlineStyle, tabBarPosition, renderUnderline, } = this.props;
        const { isMoving, transform, showNext, showPrev } = this.state;
        const isTabBarVertical = this.isTabBarVertical();
        const needScroll = tabs.length > page;
        const size = this.getTabSize(page, tabs.length);
        const Tabs = tabs.map((t, i) => {
            return this.renderTab(t, i, size, isTabBarVertical);
        });
        let cls = prefixCls;
        if (animated && !isMoving) {
            cls += ` ${prefixCls}-animated`;
        }
        let style = {
            backgroundColor: tabBarBackgroundColor || '',
        };
        let transformStyle = needScroll ? Object.assign({}, getTransformPropValue(transform)) : {};
        // const { setCurrentOffset, ...onPan } = this.onPan;
        const underlineProps = {
            style: Object.assign({}, isTabBarVertical ? { height: `${size}%` } : { width: `${size}%` }, isTabBarVertical ? { top: `${size * activeTab}%` } : { left: `${size * activeTab}%` }, tabBarUnderlineStyle),
            className: `${prefixCls}-underline`,
        };
        return <div className={`${cls} ${prefixCls}-${tabBarPosition}`} style={style}>
      {showPrev && <div className={`${prefixCls}-prevpage`}></div>}

        <div className={`${prefixCls}-content`} style={transformStyle} ref={this.setContentLayout}>
          {Tabs}
          {renderUnderline ? renderUnderline(underlineProps) :
            <div {...underlineProps}></div>}
        </div>

      {showNext && <div className={`${prefixCls}-nextpage`}></div>}
    </div>;
    }
}
DefaultTabBar.defaultProps = {
    prefixCls: 'rmc-tabs-tab-bar',
    animated: true,
    tabs: [],
    goToTab: () => { },
    activeTab: 0,
    page: 5,
    tabBarUnderlineStyle: {},
    tabBarBackgroundColor: '#fff',
    tabBarActiveTextColor: '',
    tabBarInactiveTextColor: '',
    tabBarTextStyle: {},
};



// WEBPACK FOOTER //
// ./components/tabs/rmc-tabs/DefaultTabBar.tsx